var map = {
	"./de/animals.json": [
		2178,
		178
	],
	"./de/cars.json": [
		724,
		724
	],
	"./de/city-country.json": [
		1656,
		656
	],
	"./de/food.json": [
		6978,
		978
	],
	"./de/literature.json": [
		4400,
		400
	],
	"./de/people.json": [
		2248,
		248
	],
	"./de/sports.json": [
		728,
		728
	],
	"./de/things.json": [
		1856,
		856
	],
	"./de/tv.json": [
		5408,
		408
	],
	"./de/web.json": [
		7704,
		704
	],
	"./en/animals.json": [
		6272,
		272
	],
	"./en/cars.json": [
		4468,
		468
	],
	"./en/city-country.json": [
		4788,
		788
	],
	"./en/food.json": [
		3928,
		928
	],
	"./en/literature.json": [
		7842,
		842
	],
	"./en/people.json": [
		9688,
		307
	],
	"./en/sports.json": [
		7920,
		920
	],
	"./en/things.json": [
		5156,
		156
	],
	"./en/tv.json": [
		3508,
		508
	],
	"./en/web.json": [
		688,
		688
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 740;
module.exports = webpackAsyncContext;